import styled from "styled-components";

export const Container = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: #f8f9fa;
  color: #333;
  text-align: center;

  .button_back {
    margin-top: 2rem;
    padding: 0.75rem 1.5rem;
    border: none;
    border-radius: 30px;
    background: #111;
    color: #fff;
    font-size: 0.95rem;
    font-weight: 500;
    cursor: pointer;
    transition: background 0.3s ease;
    text-decoration: none;

    &:hover {
        background: #333;
    } 
  }
`;

export const Title = styled.h1`
  font-size: 6rem;
  font-weight: 700;
  margin: 0;
`;

export const Message = styled.p`
  font-size: 1.25rem;
  margin-top: 0.5rem;
  color: #666;
`;
